import React, { Component } from "react";
import Header from "../../../Components/MainLayout/Header";
import axios from "axios";
import { connect } from "react-redux";
import Loader from "../../../Components/MainLayout/Loader";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class ChangePassword extends Component {
  state = {
    password: "",
    passwordLength: false,
    containsNumbers: false,
    isUpperCase: false,
    containsSymbols: false,
    submitClick: false,
    passwordUpdated: false,
  };

  // check to see if there is any number
  checkForNumbers(string) {
    var matches = string.match(/\d+/g);
    this.setState({
      containsNumbers: matches != null ? true : false,
    });
  }

  // check for upper case
  checkForUpperCase(string) {
    var matches = string.match(/[A-Z]/);
    this.setState({
      isUpperCase: matches != null ? true : false,
    });
  }

  // check for symbols
  checkForSymbols(string) {
    var symbols = new RegExp(/[^A-Z a-z0-9]/);
    this.setState({
      containsSymbols: symbols.test(string) ? true : false,
    });
  }

  // handle password
  handleChange = (input) => (e) => {
    let targetValue = e.target.value.replace(/\s/g, "");
    this.checkForNumbers(targetValue);
    this.checkForUpperCase(targetValue);
    this.checkForSymbols(targetValue);
    this.setState({
      [input]: targetValue,
      passwordLength: targetValue.length > 7 ? true : false,
    });
  };

  handleSubmit = () => {
    if (
      this.state.passwordLength &&
      this.state.containsNumbers &&
      this.state.isUpperCase &&
      this.state.containsSymbols
    ) {
      this.setState({ submitClick: true });
      var form_data = new FormData();
      form_data.append("password", this.state.password);
      axios
        .put(`/api/usercreate/${this.props.user.id}`, form_data)
        .then((response) => {
          if (response.status === 200) {
            this.setState({
              passwordUpdated: true,
              submitClick: false,
              password: "",
              passwordLength: false,
              containsNumbers: false,
              isUpperCase: false,
              containsSymbols: false,
            });

            // toast("Password Updated Successfully", {
            //   type: "success",
            //   position: toast.POSITION.BOTTOM_CENTER,
            //   autoClose: 2000,
            // });
            // customToast.success("Password Updated Successfully", {
            //   transition: Zoom,
            //   draggable: true,
            //   autoClose: 1000,
            //   position: "bottom-center",
            // });
          }
        })
        .catch((error) => {
          // toast(error.message, {
          //   type: "error",
          //   position: toast.POSITION.BOTTOM_CENTER,
          //   autoClose: 2000,
          // });
          // customToast.success(error.message, {
          //   transition: Zoom,
          //   draggable: true,
          //   autoClose: 1000,
          //   position: "bottom-center",
          // });
        });
    } else {
    }
  };
  render() {
    let {
      password,
      passwordLength,
      containsNumbers,
      isUpperCase,
      containsSymbols,
    } = this.state;
    return (
      <div>
        <Header title="Change Password" />
        <div className="container py-3">
          <div className="th-12 th-primary">Change Password</div>
          <div className="th-12 th-grey">Please input a new password</div>

          <div className="input-group input-group mt-3">
            <input
              className="form-control th-input-primary"
              placeholder="New Password"
              type="password"
              onChange={this.handleChange("password")}
              value={password}
            />
          </div>
          <div className="py-3">
            <h6 className="th-12">For a strong password:</h6>
            <div className={passwordLength ? "th-12 text-success" : "th-12"}>
              {passwordLength ? (
                <i class="fa fa-check pr-2" aria-hidden="true"></i>
              ) : null}
              Add More than 8 characters
            </div>
            <div className={containsNumbers ? "th-12 text-success" : "th-12"}>
              {containsNumbers ? (
                <i class="fa fa-check pr-2" aria-hidden="true"></i>
              ) : null}
              Add numbers
            </div>
            <div className={isUpperCase ? "th-12 text-success" : "th-12"}>
              {isUpperCase ? (
                <i class="fa fa-check pr-2" aria-hidden="true"></i>
              ) : null}
              Add UpperCase
            </div>
            <div className={containsSymbols ? "th-12 text-success" : "th-12"}>
              {containsSymbols ? (
                <i class="fa fa-check pr-2" aria-hidden="true"></i>
              ) : null}
              Add Symbols
            </div>
          </div>
          {this.state.submitClick &&
          this.state.passwordLength &&
          this.state.containsNumbers &&
          this.state.isUpperCase &&
          this.state.containsSymbols ? (
            <button type="button" className="th-btn-primary-outline py-2 w-100">
              <Loader />
              <span className="pl-2">Updating</span>
            </button>
          ) : (
            <button
              type="button"
              className="th-btn-primary py-2 w-100"
              onClick={this.handleSubmit}
            >
              Change Password
            </button>
          )}

          {this.state.passwordUpdated ? (
            <div className="th-12 text-success text-center py-3">
              <i class="fa fa-check pr-2" aria-hidden="true"></i>
              Password Updated Successfully
            </div>
          ) : // <p className="th-12 text-center py-3">
          //   Password Updated Successfully
          // </p>
          null}
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(ChangePassword);
